// extracted by mini-css-extract-plugin
module.exports = {"search":"HeroSearch_search__3jwd7"};